import React from "react";

const BackgroundTestSimple = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(45deg, #FFC107, #FFB300, #FFD54F)',
      padding: '20px'
    }}>
      <h1 style={{ 
        color: 'white', 
        fontSize: '48px', 
        textAlign: 'center',
        textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
      }}>
        🎨 BACKGROUND TEST 🎨
      </h1>
      
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        margin: '20px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
      }}>
        <h2 style={{ color: 'black', fontSize: '24px' }}>If you can see this, the background is working!</h2>
        <p style={{ color: 'black', fontSize: '16px' }}>
          This page should have a bright amber gradient background.
        </p>
      </div>
    </div>
  );
};

export default BackgroundTestSimple;



